<script>
import { PaladinCoreStateHelpers } from '@paladin/core'

export default {
  page() {
    return {
      title: 'People',
    }
  },
  components: {},
  computed: {
    ...PaladinCoreStateHelpers.userComputed,
  },
    props: {
    identity: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    }
  },
  mounted() {
    // console.log(this.user)
  },
  methods: {},
}
</script>

<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-6">
              <b-nav pills vertical>
                <b-nav-item :to="{ name: 'people-all' }">
                  Search
                </b-nav-item>
                <b-nav-item :to="{ name: 'people-owned' }">
                  Managed by me
                </b-nav-item>
                <b-nav-item v-if="isChiRhosOwner || isTenantOwner || isTenantAdmin" :to="{ name: 'people-deactivated' }">
                  Deactivated
                </b-nav-item>
                <b-nav-item :to="{ name: 'people-relationships' }">
                  Relationships
                </b-nav-item>
                <b-nav-item :to="{ name: 'people-owner-requests' }">
                  Owner Requests
                </b-nav-item>
                <b-nav-item :to="{ name: 'people-favorites' }">
                  Favourites
                </b-nav-item>
                <b-nav-item :to="{ name: 'people-add' }">
                  Add Person
                </b-nav-item>
                <!-- <b-nav-item :to="">Another Link</b-nav-item>
                <b-nav-item disabled>Disabled</b-nav-item> -->
              </b-nav>
            </div>
            <div class="col-xl-10 col-lg-10 col-md-6">
              <!-- <transition
                name="fade"
                mode="out-in"> -->
              <RouterView :key="$route.fullPath" />
              <!-- </transition> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
